import { render } from "./GetSupport.vue?vue&type=template&id=46fd4f70&scoped=true"
import script from "./GetSupport.vue?vue&type=script&lang=js"
export * from "./GetSupport.vue?vue&type=script&lang=js"

import "./GetSupport.vue?vue&type=style&index=0&id=46fd4f70&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fd4f70"]])

export default __exports__